import React from 'react';

import { renderImage } from '../image/image';

import './oneImagePage.scss';

export function renderOneImagePage(image: string, title: string, subtext: string = ''): JSX.Element {
    const subtitle = subtext !== '' ? <div className='oneimagepage-subtitle'>{subtext}</div> : null;

    return (
        <React.Fragment>
            {renderImage(image, 'oneimagepage-image')}
            <h2 className='oneimagepage-title'>{title}</h2>
            {subtitle}
        </React.Fragment>
    );
}
